export const singleLetter = '^[A-Za-z]'
export const textInput = '[ \#&\(\),\-\/.0-9A-Za-z]*'